import { Form } from 'react-bootstrap';

const EndDateSelector = ({ endDate, setEndDate }) => {
  // const handleEndDateChange = (e) => {
  //   const value = e.target.value;
  //   setEndDate(value);
  //   if (R) {
  //     const options = {
  //       ...R.options,
  //       ...bypassOptions,
  //     };
  //     if (value) {
  //       const [year, month, day] = value.split('-').map(Number);
  //       const untilDate = new Date(year, month - 1, day, 23, 59, 59);
  //       options.until = untilDate;
  //       options.count = null;
  //     }
  //     const updatedRule = new R.constructor(options);
  //     updateRule(updatedRule);
  //   }
  // };
  return (
    <Form.Group className="mb-3">
      <div className="d-flex align-items-center mb-2">
        <Form.Label className="fw-bold text-white mb-0">End Date</Form.Label>
      </div>
      <Form.Control
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        className="bg-dark text-white  bg-primary  border-secondary"
      />
    </Form.Group>
  );
};

export default EndDateSelector;
